var map = {
	"./historia/start-button--historia.png": 4956,
	"./kultura/start-button--kultura.png": 3534,
	"./motoryzacja/start-button--motoryzacja.png": 1778,
	"./programowanie/start-button--programowanie.png": 7118,
	"./technologia/start-button--technologia.png": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3481;